import axios from '@/utils/axios';

export default {
  getUsers(data) {
    return axios.get(`/user/list`, {
      params: { 
        page: data.page,
        page_size: data.page_size,
        ...(data.key_search ? { key_search: data.key_search} : {}),
        org_id: data.org_id
      },
    });
  },
  getDetectBox(data) {
    return axios.post(`/template/${data.id}/auto-detect`, {'fields': data.fields});
  },
  create (data) {
    return axios.post(`/user/create`, data);
  },
  getDetail (data) {
    return axios.get(`/user/${data.id}`);
  },
  update (data) {
    return axios.post(`/user/edit/${data.id}`, data);
  },
  delete (data) {
    return axios.delete(`/user/${data.id}`);
  },
  settingTemplate(data) {
    return axios.post(`/user/${data.id}/setting-template`, data)
  },
  getCollectionUser(data) {
    return axios.get(`/user/${data.id}/collections`)
  },
  getTemplateUser(data) {
    return axios.get(`/user/${data.id}/templates`)
  },
  updateUserAdmin (data) {
    return axios.put(`/user/${data.id}`, data);
  },
};
